import { render } from "./MiReposicion.vue?vue&type=template&id=35165375"
import script from "./MiReposicion.vue?vue&type=script&lang=js"
export * from "./MiReposicion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__